module.exports = __webpack_public_path__ + "img/office.bf1e57d7.svg";